/**
 * Барааны хүснэгтүүдэд хуваалцах жижиг хэсгүүд.
 * Татан авалт болон Хүйтэн агуулахын хүснэгт хоёулаа энэ файлаас авснаар
 * нэг ижил төрхтэй байна. (orderDelivery/ListWithDetail/ProductTable.js-тэй адил зарчим)
 */

import { Space, Typography } from 'antd';

import SharedProductImage from '../../../components/productImage';
import { formatVolume } from '../../../utils/format';

const { Text } = Typography;

/** Мөрийн дэвсгэрийн бөөрөнхийлөлт */
export const ROW_RADIUS = 8;

/** Барааны зурагны хэмжээ */
export const IMAGE_SIZE = 40;

const IMAGE_SHADOW = '0 1px 3px rgba(16, 24, 40, 0.1), 0 1px 2px rgba(16, 24, 40, 0.06)';

/** Барааны нэрийн хамгийн их өргөн (урт бол ellipsis + tooltip) */
export const TITLE_MAX_WIDTH = 320;

/**
 * Төлөв бүрийн бүдэг дэвсгэр — төлвийн badge-ийн өнгөтэй ижил
 * (styles/orderStatusBadge.less дэх background)
 */
export const STATUS_BG = {
  created: '#e8f7ff',
  delivered: '#ecfdf3',
  canceled: '#fef3f2',
  completed: '#ecfdf3',
};

/** Тоо болгож хөрвүүлнэ, болохгүй бол 0 (NaN гарахаас хамгаална) */
export const num = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

/** Жагсаалтаас сонгосон талбарын нийлбэр */
export const sumBy = (list = [], pick) => list.reduce((total, item) => total + num(pick(item)), 0);

/**
 * Мөрийн cell тус бүрд төлвийн дэвсгэрийг тавина. Inline тул antd-ийн hover
 * дэвсгэрээс давуу. Мөр бүр тусдаа "карт" шиг харагдахын тулд эхний/сүүлийн
 * cell-д л радиус авна.
 */
export const statusCellProps = (status, isFirst, isLast) => {
  const bg = STATUS_BG[status];
  if (!bg) return {};

  return {
    style: {
      backgroundColor: bg,
      borderTopLeftRadius: isFirst ? ROW_RADIUS : 0,
      borderBottomLeftRadius: isFirst ? ROW_RADIUS : 0,
      borderTopRightRadius: isLast ? ROW_RADIUS : 0,
      borderBottomRightRadius: isLast ? ROW_RADIUS : 0,
    },
  };
};

/** Багана бүрд төлвийн дэвсгэрийг залгана */
export const withStatusBackground = (defs, rowStatus) =>
  defs.map((col, index) => ({
    ...col,
    onCell: (record) => statusCellProps(rowStatus(record), index === 0, index === defs.length - 1),
  }));

/** Барааны зураг: 40x40, preview-гүй. Зураггүй / ачаалагдаагүй бол icon харуулна */
export const ProductImage = ({ src, alt = 'Барааны зураг' }) => (
  <SharedProductImage
    src={src}
    alt={alt}
    size={IMAGE_SIZE}
    style={{ objectFit: 'cover', borderRadius: 4, boxShadow: IMAGE_SHADOW }}
  />
);

/** Хоёр мөр текст: дээр үндсэн, доор нэмэлт (жижиг, сааралдуу) */
export const TwoLineText = ({ primary, secondary, align = 'start', danger = false, maxWidth }) => (
  <Space
    direction="vertical"
    size={0}
    style={{ maxWidth, alignItems: align === 'end' ? 'flex-end' : undefined }}
  >
    <Text
      type={danger ? 'danger' : undefined}
      style={{ maxWidth }}
      ellipsis={maxWidth ? { tooltip: primary } : false}
    >
      {primary}
    </Text>
    <Text type="secondary" style={{ fontSize: 12, maxWidth }} ellipsis>
      {secondary}
    </Text>
  </Space>
);

/**
 * Эзэлхүүн — см³
 *
 * Өмнө нь `Math.trunc` байсан тул 1-ээс бага эзэлхүүн ЧИМЭЭГҮЙ 0 болж, бодит
 * утга алга болдог байв (жин дээрх `formatKg`-тай ижил согог).
 */
export const VolumeText = ({ value }) => (
  <>
    {`${formatVolume(num(value))} см`}
    <sup>3</sup>
  </>
);

/** Барааны зураг + нэр + SKU/баркод */
export const ProductCell = ({ image, title, code, danger = false }) => (
  <Space size={12} align="center">
    <ProductImage src={image} />
    <TwoLineText danger={danger} primary={title} secondary={code} maxWidth={TITLE_MAX_WIDTH} />
  </Space>
);

/** № багана — бүх хүснэгтэд ижил */
export const indexColumn = {
  key: 'index',
  title: '№',
  width: 48,
  align: 'center',
  render: (_, record, index) => <Text type="secondary">{index + 1}</Text>,
};
